<mat-toolbar class="global-header">
  @if (showMenuToggle) {
    <button mat-icon-button class="mobile-toggle" (click)="onToggleSidebar()" aria-label="Toggle sidebar">
      <mat-icon>menu</mat-icon>
    </button>
  }

  <div class="header-left">
    <a routerLink="/modules" class="back-to-modules" title="Switch Module" i18n-title>
      <mat-icon>apps</mat-icon>
    </a>
    @if (showMenuToggle) {
      <div class="module-title-container">
        <mat-icon class="module-icon">business_center</mat-icon>
        <span class="module-title">{{ moduleTitle }}</span>
      </div>
    }
  </div>

  <span class="spacer"></span>

  @if (actingPost.featureEnabled() && actingPost.confirmed()) {
    <span class="acting-as-indicator">{{ actingPost.activeLabel() }}</span>
  }

  <app-header-actions></app-header-actions>
</mat-toolbar>
